// Module
var code = "<h3>Add User</h3> <div class=\"card\"> <h5>Add Profile</h5> <hr/> <div id=\"user-form\" class=\"grid pt-8\"> </div> </div> <div class=\"flex justify-end items-center\"> <button id=\"updateProfileBtn\" onclick=\"thsPage.addUser()\" class=\"mt-8\">Add user</button> </div> ";
// Exports
export default code;